module.exports = __webpack_public_path__ + "img/09.78f9f447.jpg";